import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { createQueryClient } from './providers/queryClient';
import { router } from './routes/router';
import './styles/theme.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found');

const queryClient = createQueryClient();

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
